export default {
  title: "Fornitori",
  description: "Gestisci i tuoi fornitori di nozze",
  subtitle: "Aggiungi e gestisci i tuoi fornitori",
  addVendor: "Aggiungi Fornitore",
  editVendor: "Modifica Fornitore",
  deleteVendor: "Elimina Fornitore",
  noVendors: "Nessun fornitore trovato",
  addFirstVendor: "Aggiungi il tuo primo fornitore",
  hired: "Assunto",
  engagedVendors: "Fornitori Assunti",
  noEngagedVendors: "Nessun fornitore assunto ancora",
  allVendors: "Tutti i Fornitori",
  more: "altro",
  vendorDeleted: "Fornitore eliminato con successo",
  vendorCreated: "Fornitore creato con successo",
  vendorUpdated: "Fornitore aggiornato con successo",
  totalVendors: "{{count}} fornitori",
  
  categories: {
    venue: "Location",
    religious_venue: "Luogo Religioso",
    city_hall: "Municipio",
    catering: "Catering",
    photography: "Fotografia",
    videography: "Videografia",
    music: "Musica",
    florist: "Fiorista",
    cake: "Torta",
    dress: "Vestito",
    suit: "Abito",
    hair_makeup: "Parrucchiere e Trucco",
    decoration: "Decorazione",
    transportation: "Trasporto",
    flowers: "Fiori",
    transport: "Trasporto",
    beauty: "Bellezza",
    other: "Altro",
    select: "Seleziona una categoria",
    none: "Nessuno",
    photos: "Foto",
    preparation: "Preparazione",
    reminder: "Promemoria",
    task: "Attività",
    vendor: "Fornitore",
    vendors: "Fornitori",
    custom: "Personalizzato",
    photographer: "Fotografo",
    caterer: "Catering",
    attire: "Abbigliamento"
  },

  form: {
    name: "Nome",
    category: "Categoria",
    contact: "Contatto",
    email: "Email",
    phone: "Telefono",
    address: "Indirizzo",
    website: "Sito Web",
    price: "Prezzo",
    notes: "Note",
    rating: "Valutazione",
    status: "Stato",
    statusHelper: "Lo stato determina la gestione del budget e delle attività.",
    contactName: "Nome Contatto",
    deposit: "Acconto",
    depositPaid: "Acconto Pagato",
    contractSigned: "Contratto Firmato",
    country: "Paese",
    errors: {
      nameRequired: "Il nome è obbligatorio",
      categoryRequired: "La categoria è obbligatoria",
      statusRequired: "Lo stato è obbligatorio",
      pricePositive: "Il prezzo deve essere positivo",
      depositPositive: "L'acconto deve essere positivo",
      capacityPositive: "La capacità deve essere un numero positivo"
    },
    new: "Nuovo Fornitore",
    edit: "Modifica Fornitore",
    title: "Dettagli Fornitore",
    namePlaceholder: "Nome Fornitore",
    company: "Azienda",
    categoryPlaceholder: "Seleziona una categoria",
    emailPlaceholder: "Indirizzo Email",
    phonePlaceholder: "Numero di Telefono",
    websitePlaceholder: "URL Sito Web",
    addressPlaceholder: "Indirizzo Fornitore",
    notesPlaceholder: "Note Aggiuntive",
    submit: "Salva",
    cancel: "Annulla",
    confirmCancel: "Annulla",
    contactInfo: "Informazioni di Contatto",
    capacity: "Capacità Massima",
    capacityPlaceholder: "Numero massimo di persone",
    contactNamePlaceholder: "Nome Contatto",
    description: "Descrizione",
    dueDate: "Data di Scadenza",
    priority: "Priorità"
  },

  status: {
    contacted: "Contattato",
    quote: "Preventivo Ricevuto",
    booked: "Prenotato",
    hired: "Assunto",
    deposit_paid: "Acconto Pagato",
    paid: "Pagato",
    cancelled: "Annullato",
    to_contact: "Da Contattare",
    meeting_scheduled: "Incontro Programmato",
    meetingScheduled: "Incontro Programmato",
    quote_received: "Preventivo Ricevuto",
    quoteReceived: "Preventivo Ricevuto",
    depositPaid: "Acconto Pagato",
    completed: "Completato",
    researching: "In Ricerca",
    confirmed: "Confermato",
    pending: "In Sospeso",
    declined: "Rifiutato"
  },

  actions: {
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    contact: "Contatta",
    book: "Prenota",
    add: "Aggiungi",
    addLong: "Aggiungi nuovo fornitore",
    importGuests: "Importa ospiti"
  },

  messages: {
    vendorAdded: "Fornitore aggiunto con successo",
    vendorUpdated: "Fornitore aggiornato con successo",
    vendorDeleted: "Fornitore eliminato con successo",
    error: "Si è verificato un errore",
    createSuccess: "Fornitore aggiunto con successo",
    updateSuccess: "Fornitore aggiornato con successo",
    deleteSuccess: "Fornitore eliminato con successo",
    deleteConfirm: "Sei sicuro di voler eliminare questo fornitore?"
  },

  confirm: {
    delete: "Sei sicuro di voler eliminare questo fornitore?",
    budgetRemoval: {
      title: "Rimozione Budget",
      message: "Sei sicuro di voler eliminare il budget associato a questo fornitore?",
      confirm: "Sì, elimina",
      cancel: "Annulla"
    }
  },

  confirmations: {
    delete: "Sei sicuro di voler eliminare questo fornitore?"
  },

  logs: {
    addingVendor: "Aggiunta fornitore in corso...",
    updatingVendor: "Aggiornamento fornitore in corso..."
  },

  errors: {
    submit: "Errore nel salvataggio del fornitore",
    addVendor: "Errore nell'aggiunta del fornitore",
    updateVendor: "Errore nell'aggiornamento del fornitore",
    deleteVendor: "Errore nell'eliminazione del fornitore",
    loadVendors: "Errore nel caricamento dei fornitori",
    userOrWeddingNotFound: "Utente o evento non trovato"
  },

  search: {
    title: "Trova Fornitori",
    searchPlaceholder: "Cerca fornitori",
    locationPlaceholder: "Città o CAP",
    categoryPlaceholder: "Seleziona una categoria",
    sort: "Ordina per",
    sortOptions: {
      relevance: "Rilevanza",
      rating: "Valutazione",
      reviews: "Recensioni",
      distance: "Distanza",
      name: "Nome"
    },
    findVendors: "Trova Fornitori",
    googleShort: "Cerca",
    googlePlaceholder: "Cerca un fornitore",
    googleResults: "Risultati Ricerca",
    googleNoResults: "Nessun risultato trovato",
    googleError: "Si è verificato un errore durante la ricerca",
    googleErrorShort: "Errore di ricerca",
    locationRequired: "Inserisci una località per la ricerca",
    countries: {
      FR: "🇫🇷 Francia",
      BE: "🇧🇪 Belgio",
      CH: "🇨🇭 Svizzera",
      ES: "🇪🇸 Spagna",
      IT: "🇮🇹 Italia",
      DE: "🇩🇪 Germania",
      GB: "🇬🇧 Regno Unito",
      IE: "🇮🇪 Irlanda",
      CA: "🇨🇦 Canada",
      US: "🇺🇸 Stati Uniti",
      AU: "🇦🇺 Australia",
      OTHER: "🌍 Altro"
    },
    filters: {
      title: "Filtri",
      category: "Categoria",
      status: "Stato",
      search: "Cerca",
      country: "Paese",
      location: "Dove?",
      radius: "Raggio"
    },
    google: "Ricerca Google",
    googleLong: "Cerca su Google (luoghi, aziende, ecc.)",
    placeholder: "Città o CAP...",
    noResults: "Nessun risultato trovato",
    noResultsDescription: "Prova a modificare i criteri di ricerca o ad ampliare l'area geografica.",
    reset: "Reimposta ricerca",
    searching: "Ricerca in corso",
    searchingDescription: "Stiamo cercando i migliori fornitori...",
    addVendor: "Aggiungi questo fornitore",
    add: "Aggiungi",
    site: "Sito web",
    phone: "Telefono",
    resultsCountSingular: "fornitore trovato",
    resultsCountPlural: "fornitori trovati",
    reviews: "recensioni",
    recommended: "Consigliato",
    new: "Nuovo"
  },
  
  empty: {
    title: "Nessun fornitore",
    description: "Inizia ad aggiungere i tuoi fornitori di nozze"
  },

  filters: {
    title: "Filtri",
    category: "Categoria",
    status: "Stato",
    all: "Tutti",
    group: "Gruppo",
    search: "Cerca fornitore",
    events: "Eventi",
    clear: "Cancella filtri",
    apply: "Applica",
    previous: "Precedente",
    next: "Successivo",
    reset: "Reimposta",
    allCategories: "Tutte le categorie"
  },

  groups: {
    family: "Famiglia",
    friends: "Amici",
    colleagues: "Colleghi",
    other: "Altro"
  },

  events: {
    ceremony: "Cerimonia",
    reception: "Ricevimento",
    both: "Entrambi"
  },

  sort: {
    title: "Ordina per",
    options: {
      name: "Nome",
      category: "Categoria",
      status: "Stato",
      price: "Prezzo",
      notes: "Note"
    }
  },

  modal: {
    title: "Dettagli Fornitore",
    readOnly: "Sola lettura",
    edit: "Modifica",
    share: "Condividi",
    personalInfo: "Informazioni Personali",
    companyInfo: "Informazioni Aziendali",
    contactInfo: "Informazioni di Contatto",
    notes: "Note",
    budget: "Budget",
    documents: "Documenti",
    timeline: "Cronologia",
    tasks: "Attività",
    reviews: "Recensioni",
    messages: "Messaggi",
    payments: "Pagamenti",
    contracts: "Contratti"
  },

  details: {
    contact: "Contatto",
    pricing: "Prezzi",
    documents: "Documenti",
    appointments: "Appuntamenti",
    payments: "Pagamenti"
  },

  vendors: {
    filters: {
      status: "Stato",
      all: "Tutti",
      group: "Gruppo",
      events: "Eventi"
    },
    status: {
      confirmed: "Confermato",
      pending: "In Sospeso",
      declined: "Rifiutato"
    },
    groups: {
      family: "Famiglia",
      friends: "Amici",
      colleagues: "Colleghi",
      other: "Altro"
    },
    events: {
      ceremony: "Cerimonia",
      reception: "Ricevimento",
      both: "Entrambi"
    },
    sort: {
      options: {
        name: "Nome",
        category: "Categoria",
        status: "Stato",
        price: "Prezzo",
        notes: "Note"
      }
    }
  },

  success: {
    budgetUpdated: "Budget aggiornato con successo",
    vendorAdded: "Fornitore aggiunto con successo",
    vendorAndBudgetUpdated: "Fornitore e budget aggiornati con successo",
    vendorUpdated: "Fornitore aggiornato con successo"
  }
};
